module.exports = __webpack_public_path__ + "4ecf2a25397433e609398dd4a13c6903.png";